import styles from "./SubmissionLoader.module.scss"
const SubmissionLoader = () => {
  return <div className={styles.loaderWrapper}>
    <div className={styles.dotLoader}>
    </div>
  </div>
}

export default SubmissionLoader